import React, { useEffect, useState } from 'react';
import ENDPOINT from '../../../globals/api-endpoint';
import styled from 'styled-components';
import media from 'styled-media-query';
import NumberFormat from 'react-number-format';
import flat2 from '../assets/flat2.png';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const ServiceDetailContainer = styled.div``;

const ServiceStyled = styled.div`
	display: grid;
	grid-template-columns: 1fr 2fr;
	grid-gap: 20px;

	${media.lessThan('medium')`
		grid-template-columns: 1fr;
	`}
`;

const Thumbnail = styled.div`
	background: white;
	width: 100%;
	height: 200px;
`;

const Detail = styled.div`
	
`;

const P = styled.p`
	margin-bottom: 5px;
`;

const H3 = styled.h3`
	margin-bottom: 10px;
`;

const H4 = styled.h4`
	margin-bottom: 10px;
`;

const Deskripsi = styled.div`
	padding: 10px;
	margin: 10px 0;
	border: 1px solid ${props => props.theme.green};
	border-radius: 5px;
`;

const Img = styled.img`
	height: 100%;
	width : 100%;
	object-fit: cover;
  object-position: center;
`;


const Green = styled.span`
	color: ${props => props.theme.green};
`;

const ServiceDetail = (props) => {
	const serviceId = props.match.params.serviceId;

	const [service, setService] = useState({});
	const [category, setCategory] = useState({});
	const [user, setUser] = useState({});

	const [isLoading, setIsloading] = useState(true);
	const [isFailed, setIsFailed] = useState(null);

	useEffect(() => {
		const fetchData = () => { 
			setIsloading(true);
			fetch(ENDPOINT.SERVICE_DETAIL + serviceId)
			.then(res => res.json())
			.then(res => {
				setService(res.service);
				setCategory(res.service.category);
				setUser(res.service.user);
			})
			.catch(err => {
				setIsFailed(true);
				console.log(err);
			})
			.finally(res => {
				setIsloading(false);
			});
		}
		fetchData();
	}, [serviceId]);

	useEffect(() => {
	  window.scrollTo(0, 0)
	}, []);

	if (isLoading) {
		return(
			<div className="loading">
				<div className="sk-folding-cube">
				  <div className="sk-cube1 sk-cube"></div>
				  <div className="sk-cube2 sk-cube"></div>
				  <div className="sk-cube4 sk-cube"></div>
				  <div className="sk-cube3 sk-cube"></div>
				</div>
			</div>
		);
	} else {
		if (isFailed) {
			return(
				<P>Failed</P>
			);
		} else {
			return(
				<ServiceDetailContainer>
					<Helmet>
						<title>{service.name} | bantuin</title>
					</Helmet>
					<ServiceStyled>
						<Thumbnail>
							<Img src={flat2} alt={service.name}/>
						</Thumbnail>
						<Detail>
							<H3>{service.name}</H3>
							<P>Sebuah layanan dari <NavLink to={'/profil/' + user._id}>
							<Green>{user.name}</Green></NavLink></P>
							<P><NumberFormat value={service.price} displayType={'text'} thousandSeparator={true} prefix={'Rp.'} /></P>
							<Deskripsi>
								<H4>Deskripsi Layanan</H4>
								<P>{service.description}</P>
							</Deskripsi>
							<P>Kategori: {category.name}</P>
							<P>
								{ user.contact ? (
									<span>Jika anda tertarik dengan layanan ini, anda bisa mengubungi {user.contact}. { user.whatsapp ? (<span>Anda juga dapat menghubungi melalui whatsapp di {user.whatsapp}</span>) : (null) }</span>
									) : (null) }
							</P>
							<P>Demo : {service.demo ? (<a href={service.demo}>{service.demo}</a>) : (<span>-</span>)}</P>
						</Detail>
					</ServiceStyled>
				</ServiceDetailContainer>
			);
		}
	}
}

export default ServiceDetail;